// Viewer preferences shared by every web player. They live in localStorage["plyr"] for historical
// reasons: the key must not change, or saved speed/volume would be lost.

export function readPlyrStorage() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem("plyr") || "null");
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

// Merges into the existing JSON so keys written by the other players survive.
export function writePlyrStorage(patch) {
  try {
    const current = readPlyrStorage() || {};
    window.localStorage.setItem("plyr", JSON.stringify({ ...current, ...patch }));
  } catch {
    // storage unavailable or full - the preference just won't persist
  }
}

// Ties go to the lower rate.
export function nearestRate(rates, speed) {
  if (!rates?.length) return speed;
  return rates.reduce((best, rate) => (Math.abs(rate - speed) < Math.abs(best - speed) ? rate : best));
}
